/**
 * The public marketing surface — the only pages Google's tags may load on.
 *
 * This allowlist is a privacy boundary, not a routing convenience. Loading
 * Google's tag across the authenticated app would hand Google a view of
 * customers' internal navigation — job boards, submissions, report URLs — to buy
 * exactly nothing: ad attribution ends at sign-up, and product analytics is
 * PostHog's job. It is also the reason this is an allowlist rather than a
 * blocklist of app routes; a new authenticated route added later must not
 * silently opt itself in.
 *
 * Lives in `lib/` rather than beside the component because two things now
 * depend on it (the Ads tag and the GA4 tag) and because keeping it free of
 * `next/script` and `next/navigation` imports lets it be tested as what it is:
 * a pure predicate.
 */
const PUBLIC_PREFIXES = ['/pricing', '/for', '/franchises', '/templates', '/email-entry']

export function isPublicMarketingPath(pathname: string | null): boolean {
  if (!pathname) return false
  if (pathname === '/') return true
  return PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}
